import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src048896024/src/www/src/layouts/ApiLayout.js";
import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import defaultToast from 'src/examples/Toast/default';
export const query = graphql`
  query ToastQuery {
    metadata: componentMetadata(displayName: { eq: "ToastContainer" }) {
      ...ComponentApi_metadata
    }
  }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "toast-messages"
    }}>{`Toast Messages`}</h1>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`It is a small message that shows up in a box at the corner of the screen and disappears on its own after a few seconds. It is simple feedback about an operation in which current activity remains visible and interactive.`}</p>
    <img src={require('src/assets/structure/stb_toast-messages-structure.jpg')} srcSet={`${require('src/assets/structure/stb_toast-messages-structure@2x.jpg')} 2x`} className="u-maxWidthFull" alt="Toast Messages" />
    <ol className="u-textGray u-marginTopTiny">
  <li>
  Heading
    <i className="u-text200">
- A title to explain what the message content is about.
    </i>
  </li>
  <li>
  Message
    <i className="u-text200"> - The information that the system wants to send to users. Message content can include paragraphs and links.</i>
  </li>
  <li>
  Close button
    <i className="u-text200"> - Optional to close the message immediately.</i>
  </li>
  <li>
  Progress bar
    <i className="u-text200"> - The display time remaining of the message before it disappears.</i>
  </li>
    </ol>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <CodeView codeText={defaultToast} mdxType="CodeView" />
    <h2 {...{
      "id": "design-reference"
    }}>{`Design Reference`}</h2>
    <p>{`N/A`}</p>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ComponentApi metadata={props.data.metadata} mdxType="ComponentApi" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      